import React, { useState, useEffect } from 'react';
import { SvgIcon } from '@quillbot/design-system';
import PasteButton from '@Common/quillElements/button/PasteButton';
import { copyAllIcon } from 'public/images/svgPath.json';
import { useSelector } from 'react-redux';
import { RootState } from '../models/redux/store';

interface IProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  style?: {};
  className?: string;
}

function PasteBtn(props: IProps) {
  const [shouldDisplayPasteButton, setShouldDisplayPasteButton] =
    useState(true);
  const platform = useSelector((state: RootState) => state.common.platform);

  useEffect(() => {
    if (!navigator || !navigator.clipboard || !navigator.clipboard.readText) {
      setShouldDisplayPasteButton(false);
    }
  }, []);

  return shouldDisplayPasteButton && !platform?.isExtension ? (
    <PasteButton
      style={props.style}
      variant="text"
      className={props.className}
      onClick={props.onClick}
    >
      <SvgIcon style={{ fontSize: 'inherit', marginRight: '5px' }}>
        <path fill="primary" {...copyAllIcon} />
      </SvgIcon>
      Paste Text
    </PasteButton>
  ) : null;
}

export default PasteBtn;
